export enum CustomerType {
  PRE_USER = 'PRE_USER',
  USER = 'USER',
}



// WEBPACK FOOTER //
// ./src/app/pages/customers/enums/customer-type.enum.ts